import React, { useContext } from 'react';
import DataTableContext from '../../../context/DataTableContext';

export const Search = () => {
  const context = useContext(DataTableContext);

  const onChange = (e) => {
    context.setQuickFilter(e.target.value);
  };

  return (
    <div className="form-inline search-input">
      <input
        className="form-control mr-sm-1"
        type="search"
        placeholder="Busca rápida"
        aria-label="Busca rápida"
        value={context.searchTerms}
        onChange={onChange} />
    </div>
  );
};
